import { Component, OnInit } from '@angular/core';
import { Products } from 'src/app/model/products.model';
import { OrderService } from 'src/app/services/order/order.service';
import { Router } from '@angular/router';
import { SitesettingsService } from 'src/app/services/settings/sitesettings.service';

@Component({
  selector: 'app-portalsetting',
  templateUrl: './portalsetting.component.html',
  styleUrls: ['./portalsetting.component.css']
})
export class PortalsettingComponent implements OnInit {

  data: any;

  constructor(private settingServices: SitesettingsService, private router: Router) { }

  ngOnInit() {
    this.getOrderList();
  }

  getOrderList() {
    this.settingServices.getSiteSettingsKeys().subscribe(
      (data: any) => {
        this.data = data;
        console.log(this.data);
      }
    )
  }

  editKey(keyid: string) {
    if (keyid != null) {
      // alert(keyid);
      this.router.navigate(['/editsettings', keyid]);
    }
  }

}
